import { cva } from 'class-variance-authority';

const stepperKnobStyles = [
  'h-8',
  'aspect-square',
  'rounded-full',
  'flex',
  'items-center',
  'justify-center',
  'cursor-pointer',
  'relative',
  'border-[3px]',
];

const stepperKnobStylesSAG = cva([
  ...stepperKnobStyles,
  'bg-transparent',

  'data-[status=done]:border-[#007993]',
  'data-[status=done]:text-[#007993]',
  'dark:data-[status=done]:border-[#00CCCC]',
  'dark:data-[status=done]:text-[#00CCCC]',

  'data-[status=error]:border-[#D72339]',
  'data-[status=error]:text-[#D72339]',
  'dark:data-[status=error]:border-[#FF7687]',
  'dark:data-[status=error]:text-[#FF7687]',

  'data-[status=active]:border-[#005159]',
  'data-[status=active]:text-[#005159]',
  'dark:data-[status=active]:border-[#00FFB9]',
  'dark:data-[status=active]:text-[#00FFB9]',

  'data-[status=default]:border-[#4C4C68]',
  'data-[status=default]:text-[#4C4C68]',
  'dark:data-[status=default]:border-[#B3B3BE]',
  'dark:data-[status=default]:text-[#B3B3BE]',

  'data-[status=disabled]:border-[#B3B3BE]',
  'data-[status=disabled]:text-[#B3B3BE]',
  'dark:data-[status=disabled]:border-[#737389]',
  'dark:data-[status=disabled]:text-[#737389]',
]);

const stepperKnobStylesSHS = cva([
  ...stepperKnobStyles,
  'bg-transparent',

  'data-[status=done]:border-[#cf4b00]',
  'data-[status=done]:text-[#cf4b00]',
  'dark:data-[status=done]:border-[#cf4b00]',
  'dark:data-[status=done]:text-[#cf4b00]',

  'data-[status=error]:border-[#e7001d]',
  'data-[status=error]:text-[#e7001d]',
  'dark:data-[status=error]:border-[#e7001d]',
  'dark:data-[status=error]:text-[#e7001d]',

  'data-[status=active]:border-[#ec6602]',
  'data-[status=active]:text-[#ec6602]',
  'dark:data-[status=active]:border-[#ec6602]',
  'dark:data-[status=active]:text-[#ec6602]',

  'data-[status=default]:border-[#666666]',
  'data-[status=default]:text-[#666666]',
  'dark:data-[status=default]:border-[#ffffff]',
  'dark:data-[status=default]:text-[#ffffff]',

  'data-[status=disabled]:border-[#ededed]',
  'data-[status=disabled]:text-[#ededed]',
  'dark:data-[status=disabled]:border-[#ededed]',
  'dark:data-[status=disabled]:text-[#ededed]',
]);

export { stepperKnobStylesSAG, stepperKnobStylesSHS };
